import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Enum } from "@/utils/enums";
export default {
  name: "SearchResult",
  data: function data() {
    return {
      page: 1,
      limit: 9,
      total: 0,
      showSearch: true,
      keywords: this.$store.state.search,
      searchSuggestFuction: null,
      searchSuggestItems: [],
      searchSuggestIndex: -1,
      searchSuggestComplete: false,
      searchType: "",
      searchHandles: {},
      showTypes: false
    };
  },
  computed: {
    placeholder: function placeholder() {
      if (this.searchType == this.searchTypes.Course) {
        return "请输入课程名称";
      } else if (this.searchType == this.searchTypes.CoursePackage) {
        return "请输入课程包名称";
      } else if (this.searchType == (this.searchTypes.Book || this.searchTypes.Goods)) {
        return "请输入实物商品名称";
      } else if (this.searchType == this.searchTypes.Teacher) {
        return "请输入讲师名称";
      } else if (this.searchType == this.searchTypes.Periods) {
        return "请输入课时包名称";
      } else if (this.searchType == this.searchTypes.Oto) {
        return "请输入约课讲师名称";
      } else if (this.searchType == this.searchTypes.OpenCourse) {
        return "请输入公开课名称";
      } else if (this.searchType == this.searchTypes.Classes) {
        return "请输入班级名称";
      } else if (this.searchType == this.searchTypes.Ebooks) {
        return "请输入电子书名称";
      } else if (this.searchType == this.searchTypes.News) {
        return "请输入资讯名称";
      }

      return "";
    },
    searchTypes: function searchTypes() {
      var config = this.$store.state.commonSetting;
      var types = [{
        id: 1,
        name: "课程",
        code: "Course"
      }, {
        id: 7,
        name: "公开课",
        code: "OpenCourse"
      }, {
        id: 5,
        name: "课程包",
        code: "CoursePackage",
        hide: config.switch_package_course != 1
      }, {
        id: 8,
        name: "班级",
        code: "Classes",
        hide: config.switch_class_module != 1
      }, {
        id: 4,
        name: "实物商品",
        code: "Goods",
        hide: config.switch_goods_module != 1
      }, {
        id: 9,
        name: "电子书",
        code: "Ebooks",
        hide: config.switch_ebook_module != 1
      }, {
        id: 3,
        name: "讲师",
        code: "Teacher"
      }, {
        id: 6,
        name: "课时包",
        code: "Periods",
        hide: config.switch_contract_schedule != 1
      }, {
        id: 2,
        name: "一对一约课",
        code: "Oto",
        hide: config.switch_oto_module != 1
      }, {
        id: 10,
        name: "资讯",
        code: "News"
      }];
      var searchTypes = new Enum(types.filter(function (t) {
        return t.hide != true;
      }));
      return searchTypes;
    },
    types: function types() {
      return this.searchTypes.getOptions();
    },
    type: function type() {
      var _this = this;

      return this.types.find(function (t) {
        return t.key == _this.searchType;
      });
    }
  },
  watch: {
    show: function show(newValue) {
      this.showSearch = newValue;

      if (!newValue) {
        this.keywords = "";
        this.searchSuggestItems = [];
      }
    },
    showSearch: function showSearch(newValue) {
      this.$emit("update:show", newValue);
    },
    searchTypes: function searchTypes() {
      this.init();
    }
  },
  created: function created() {
    var _this2 = this,
        _this$searchHandles;

    this.init();
    this.searchHandles = (_this$searchHandles = {}, _defineProperty(_this$searchHandles, this.searchTypes.Course, {
      search: function search() {
        _this2.$router.push({
          name: "Course",
          query: {
            keywords: _this2.keywords
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        if (item.course_type == 3) {
          _this2.$router.push({
            name: "CourseShow",
            params: {
              id: item.id
            },
            query: {
              recommend: 3,
              title: "公开课"
            }
          });
        } else {
          _this2.$router.push({
            name: "CourseShow",
            params: {
              id: item.id
            }
          });
        }
      }
    }), _defineProperty(_this$searchHandles, this.searchTypes.OpenCourse, {
      search: function search() {
        _this2.$router.push({
          name: "OpenCourse",
          query: {
            keywords: _this2.keywords,
            course_type: 3,
            nav: 25
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        if (item.course_type == 3) {
          _this2.$router.push({
            name: "CourseShow",
            params: {
              id: item.id
            },
            query: {
              recommend: 3,
              title: "公开课"
            }
          });
        } else {
          _this2.$router.push({
            name: "CourseShow",
            params: {
              id: item.id
            }
          });
        }
      }
    }), _defineProperty(_this$searchHandles, this.searchTypes.Goods, {
      search: function search() {
        _this2.$router.push({
          name: "Goods",
          query: {
            keywords: _this2.keywords
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        _this2.$router.push({
          name: "GoodsDetail",
          params: {
            id: item.id
          }
        });
      }
    }), _defineProperty(_this$searchHandles, this.searchTypes.Ebooks, {
      search: function search() {
        _this2.$router.push({
          name: "Ebooks",
          query: {
            keywords: _this2.keywords
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        _this2.$router.push({
          name: "EbooksDetail",
          params: {
            id: item.id
          }
        });
      }
    }), _defineProperty(_this$searchHandles, this.searchTypes.Teacher, {
      search: function search() {
        _this2.$router.push({
          name: "ShowTeachers",
          query: {
            keywords: _this2.keywords
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        _this2.$router.push({
          name: "ShowTeachersDetaial",
          params: {
            id: item.id
          }
        });
      }
    }), _defineProperty(_this$searchHandles, this.searchTypes.CoursePackage, {
      search: function search() {
        _this2.$router.push({
          name: "Package",
          query: {
            keywords: _this2.keywords
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        _this2.$router.push({
          name: "PackageDetail",
          params: {
            id: item.id
          }
        });
      }
    }), _defineProperty(_this$searchHandles, this.searchTypes.Periods, {
      search: function search() {
        _this2.$router.push({
          name: "Periods",
          query: {
            keywords: _this2.keywords
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        _this2.$router.push({
          name: "PeriodsDetail",
          params: {
            id: item.id
          }
        });
      }
    }), _defineProperty(_this$searchHandles, this.searchTypes.Oto, {
      search: function search() {
        _this2.$router.push({
          name: "Oto",
          query: {
            keywords: _this2.keywords
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        _this2.$router.push({
          name: "OtoTeacherShow",
          params: {
            id: item.id
          }
        });
      }
    }), _defineProperty(_this$searchHandles, this.searchTypes.Classes, {
      search: function search() {
        _this2.$router.push({
          name: "Classes",
          query: {
            keywords: _this2.keywords
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        _this2.$router.push({
          name: "ClassesDetail",
          params: {
            id: item.id
          }
        });
      }
    }), _defineProperty(_this$searchHandles, this.searchTypes.News, {
      search: function search() {
        _this2.$router.push({
          name: "News",
          query: {
            keywords: _this2.keywords
          }
        });
      },
      searchSuggestClick: function searchSuggestClick(item) {
        _this2.$router.push({
          name: "NewsShow",
          params: {
            id: item.id
          }
        });
      }
    }), _this$searchHandles);
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this3 = this;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$nextTick();

            case 2:
              this.$refs.searchInput.focus();
              document.addEventListener("click", function () {
                _this3.showSearch = false;
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    handlePageChange: function () {
      var _handlePageChange = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(page) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.page = page;
                _context2.next = 3;
                return this.searchSuggest();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handlePageChange(_x) {
        return _handlePageChange.apply(this, arguments);
      }

      return handlePageChange;
    }(),
    init: function init() {
      this.searchType = this.searchTypes.Course;
    },
    onTypeClick: function () {
      var _onTypeClick = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(type) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.searchType = type.key;
                this.showTypes = false;
                this.page = 1;
                _context3.next = 5;
                return this.searchSuggest();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onTypeClick(_x2) {
        return _onTypeClick.apply(this, arguments);
      }

      return onTypeClick;
    }(),
    search: function search() {
      this.showSearch = false;
      var handle = this.searchHandles[this.searchType];

      if (handle) {
        handle.search();
      }
    },
    removeHTMLTag: function removeHTMLTag(str) {
      if (str) {
        str = str.replace(/<\/?[^>]*>/g, ""); //去除HTML tag

        str = str.replace(/[ | ]*\n/g, "\n"); //去除行尾空白

        str = str.replace(/\n[\s| | ]*\r/g, "\n"); //去除多余空行

        str = str.replace(/&nbsp;/gi, ""); //去掉&nbsp;
      }

      return str;
    },
    searchSuggest: function () {
      var _searchSuggest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.searchSuggestComplete = false;

                if (this.keywords) {
                  _context5.next = 4;
                  break;
                }

                this.searchSuggestItems = [];
                return _context5.abrupt("return");

              case 4:
                if (!this.searchSuggestFuction) {
                  this.searchSuggestFuction = this.$pub.debounce(
                  /*#__PURE__*/
                  _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee4() {
                    var data, list;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (_this4.keywords) {
                              _context4.next = 3;
                              break;
                            }

                            _this4.searchSuggestItems = [];
                            return _context4.abrupt("return");

                          case 3:
                            _context4.next = 5;
                            return _this4.$http.get("/api/app/keywordsPaginator", {
                              type: _this4.searchType,
                              page: _this4.page,
                              limit: _this4.limit,
                              course_type: _this4.searchType == 7 ? 3 : _this4.searchType == 1 ? 1 : "",
                              keywords: encodeURIComponent(_this4.keywords)
                            });

                          case 5:
                            data = _context4.sent;
                            list = data.data;
                            _this4.total = data.total;
                            list.forEach(function (item) {
                              item.desc = _this4.removeHTMLTag(item.details);
                              item.title = item.name ? item.name : item.title;
                              item.title = item.title.replace(new RegExp(_this4.keywords, "g"), '<span class="primary-color">' + _this4.keywords + "</span>");
                            });
                            _this4.searchSuggestItems = list;
                            _this4.searchSuggestIndex = -1;
                            _this4.searchSuggestComplete = true;

                          case 12:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  })), 200);
                }

                this.searchSuggestFuction();

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function searchSuggest() {
        return _searchSuggest.apply(this, arguments);
      }

      return searchSuggest;
    }(),
    searchSuggestUp: function searchSuggestUp() {
      if (this.searchSuggestIndex == -1) {
        return;
      }

      this.searchSuggestIndex--;
    },
    searchSuggestDown: function searchSuggestDown() {
      if (this.searchSuggestIndex == this.searchSuggestItems.length - 1) {
        return;
      }

      this.searchSuggestIndex++;
    },
    onSearchSuggestClick: function onSearchSuggestClick(item) {
      item = item || this.searchSuggestItems[this.searchSuggestIndex];

      if (!item) {
        return;
      }

      var handle = this.searchHandles[this.searchType];

      if (handle) {
        handle.searchSuggestClick(item);
      }

      this.showSearch = false;
      this.searchSuggestIndex = -1;
    },
    onInputEnter: function onInputEnter() {
      if (this.searchSuggestIndex >= 0) {
        this.onSearchSuggestClick();
      } else {
        this.search();
      }
    }
  }
};